import { jsx as _jsx } from "react/jsx-runtime";
import Add16 from '@carbon/icons-react/es/add/16';
import { Button } from '@rocketlane/ui';
import { withHideIfNotAllowed } from 'components/organisms/permission-controller';
const BaseAddButton = (props)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ _jsx(Button, {
        variant: "primary",
        type: "button",
        rightIcon: /*#__PURE__*/ _jsx(Add16, {}),
        ...props
    });
export const AddButton = withHideIfNotAllowed(BaseAddButton);
